import { List, Map as ImmutableMap } from 'immutable';
import * as ValidationScopes from 'automation-ui-flow-core/validation/ValidationScopes';
import ValidationError from 'automation-ui-flow-core/validation/ValidationError';
import FlowValidation from 'automation-ui-flow-core/validation/FlowValidation';
const getActionValidationErrors = flowValidation => {
  if (!flowValidation || !flowValidation.flowValidationErrors) {
    return ImmutableMap();
  }
  let errorsByActionId = ImmutableMap();
  flowValidation.flowValidationErrors.filter(error => ValidationScopes.ACTION === error.validationScope).forEach(error => {
    const validationError = new ValidationError(error);
    errorsByActionId = errorsByActionId.updateIn([error.actionId], List(), list => list.push(validationError));
  });
  return errorsByActionId;
};
const getFlowValidationErrors = flowValidation => {
  if (!flowValidation || !flowValidation.flowValidationErrors) {
    return List();
  }
  return List(flowValidation.flowValidationErrors.filter(error => ValidationScopes.FLOW === error.validationScope).map(error => new ValidationError(error)));
};
export const transformFlowValidationResponse = flowValidation => {
  if (!flowValidation) {
    return new FlowValidation();
  }
  return new FlowValidation({
    ACTION: getActionValidationErrors(flowValidation),
    FLOW: getFlowValidationErrors(flowValidation),
    isValid: flowValidation.valid
  });
};